import React, { useEffect,useRef } from 'react';
import MaterialTable from 'material-table';
import { forwardRef } from 'react';
import AddBox from '@material-ui/icons/AddBox';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';
import { makeStyles } from '@material-ui/core/styles';
import { NavLink } from 'react-router-dom';
import Cookies from 'js-cookie';
import { TablePagination } from '@material-ui/core';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CircularProgress from '@material-ui/core/CircularProgress';
import TextField from '@material-ui/core/TextField';
import InputLabel from '@material-ui/core/InputLabel';
import SearchIcon from '@material-ui/icons/Search';
import InputAdornment from '@material-ui/core/InputAdornment';
import API_PATH from "../../constants/config.json";
const axios = require('axios');
const API_URL = process.env.REACT_APP_BASE_URL;

//Start Css Code ....
const useStyles = makeStyles((theme) => ({
  filterTable: {
    width:'100%',
    float:'left',
    position:'relative',
    '& .MuiTableCell-head': {
      fontWeight: '600',
      fontSize: '14pt',
      background: '#fff',
      color: '#000',
      border: '1px solid #d1d1d1',
      padding: '5px',
    },
    '& .MuiFormControl-root': {
      border: '1px solid #24618E',
      borderRadius: '3px 3px 3px 3px',
      paddingLeft: '0px',
      position: 'absolute',
      padding: ' 0px 6px 0px 0px',     
      '@media only screen and (max-width: 3500px)': {
        width: '400px',
      },
      '@media only screen and (min-width: 3501px)': {
        width: '650px',
        '& input': {
          fontSize: '24pt',
        }
      },
      zIndex: 1,
      '& .MuiIconButton-root.Mui-disabled': {
        color: '#fff',
      },
      '& :hover .MuiInputAdornment-positionEnd button': {
        color: '#24618E !important',
        fontWeight: '600 !important',
      },
    },
    '& .MuiInput-underline:before': {
      borderBottom: 'none !important',
    },
    '& .MuiInputAdornment-positionStart': {
      background: '#24618E',
      color: '#fff',
      paddingLeft: '5px',
      borderRadius: '0px 3px 3px 0px',
      position: 'relative',
      left: '100%',
      '@media only screen and (max-width: 3500px)': {
        height: '32px',
        width: '43px',
      },
      '@media only screen and (min-width: 3501px)': {
        height: '60px',
        width: '70px',
        maxHeight: '60px',
        marginLeft: '-28px',
      },
    },
    '& .MuiToolbar-root ': {
      paddingLeft: '0px',
      minHeight: '45px',
    },
    '& .MuiInput-root': {
      left: '-30px',
    },
    '& .MuiInputAdornment-positionStart svg': {
      '@media only screen and (max-width: 3500px)': {
        fontSize: '31px !important',
      },
      '@media only screen and (min-width: 3501px)': {
        fontSize: '50px !important',
        marginLeft: '5px',
      },
    },
    '& td': {
      padding: '5px',
      border: '1px solid #D7D7D7',
      '@media only screen and (max-width: 3500px)': {
        fontSize: '12pt !important',
      },
      '@media only screen and (min-width: 3501px)': {
        fontSize: '24pt !important',
      },
    },
    '& th': {
      '@media only screen and (max-width: 3500px)': {
        fontSize: '12pt !important',
        padding: '5px !important',
      },
      '@media only screen and (min-width: 3501px)': {
        fontSize: '24pt !important',
        padding: '20px 5px 15px !important',
      },
    },
    '& tr:nth-child(odd)': {
      backgroundColor: '#f2f2f2'
    },    
    '& table': {
      borderRight: '1px solid #D7D7D7',
      '@media only screen and (min-width: 3501px)': {
        marginTop: '35px',
      },
    },
    '& .MuiTableCell-head:nth-child(2)': {
      textAlign: 'center',
    },
    '& .MuiTableCell-body:nth-child(2)': {
      textAlign: 'center',
    },
    '& .MuiTablePagination-select': {
      color: '#000',
    }
  },
  addNewUser: {
    position: 'absolute',
    right: '0',
    border: '1px solid #333',
    padding: '5px 25px',
    color: '#333',
    textDecoration: 'none',
    fontSize: '14pt',
    borderRadius: '5px',
    top: '0',
    marginRight: '6px',
    '&:hover': {
      boxShadow: '4px 3px 3px 0px #999',
    },
  },
  tdLink: {
    color: '#24618E',
  },
  crossCursor: {
    color: '#24618d',
    fontSize: '14pt',
    fontFamily: 'Avenir_Black',
    fontWeight: '800',
    position: 'absolute',
    width: '30px !important',
    right: '0px',
    cursor: 'pointer'
  },
  errMsg: {    
    color: '#CC0000',
    margin: '3px'
  }
}));
//End Css Code ....

const tableIcons = {
  Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
  Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
  Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
  DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
  Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
  Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
  FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
  LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
  NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
  ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
  SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
  ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
  ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />)
};

//Start Teams component code...
const Teams = props => {
  const classes = useStyles();
  const [teamList, setTeamList] = React.useState([]);
  const [pagination, setPagnation] = React.useState({ selectedPage: 1 });
  const [totalItems, setTotalItems] = React.useState(0);
  const [userAccess, setUserAccess] = React.useState(true);
  const [getLoader, setLoaderDisable] = React.useState(false);
  const [getSearchTerm, setSearchTerm] = React.useState("");
  const [hover, setHower] = React.useState(false);
  const [errSearchValue, setErrSearchValue] = React.useState(null);
  const refContainer = useRef('');
  const enteriesPerPage = 10;
  let values = {
    "pageNo": pagination.selectedPage,
    "entriesPerPage": enteriesPerPage,
  }
  useEffect(
    () => {
      getTeamsAPI();
    }, []
  )

  let pages = teamList.length > 10 ? true : false;

  //This method is use for  API call to get all teams for table data ... Start
  const getTeamsAPI = (search = "", enable = false) => {
    setLoaderDisable(true);
    try {
      axios({
        method: 'post',
        data: {
          pageNo: pagination.selectedPage,
          entriesPerPage: enteriesPerPage,
          searchEnable: enable,
          searchValue: search
        },
        headers: {
          'payload': Cookies.get('payload'),
          'agencyid': sessionStorage.getItem('agency_id')
        },
        url: API_URL + API_PATH.getTeamList,
      })
        .then(async function (response) {
          if (response.status && response.status == '200') {
            setLoaderDisable(false);
            setTeamList(response.data.result.rows);
            setTotalItems(response.data.result.count);
          } else {
            setLoaderDisable(false);
            setTeamList([]);
            setTotalItems(0)
          }

        })
        .catch(function (error) {
          if (error.response) {
            if (error.response.data.status == 403) {
              setLoaderDisable(false);
              setUserAccess(false);
              setTeamList([]);
              setTotalItems(0)
            } else {
              setLoaderDisable(false);
              setTeamList([]);
              setTotalItems(0)
            }
          } else {
            setLoaderDisable(false);
            setTeamList([]);
            setTotalItems(0)
          }
        })
    } catch (error) {
      console.error(error);
    }
  }
  //This method is use for  API call to get all teams for table data ... End

  const handleSelected = (e, selectedPage) => {
    values.pageNo = selectedPage + 1
    setPagnation({ selectedPage: selectedPage + 1 })
    getTeamsAPI();
  }
  // This method is use for page selction for table data .... end

  const kekPressSearch = (e) => {    
    if(e.key === 'Enter'){
      e.preventDefault();
      onSearch();
    }    
  }

  const searchField = (e) => {
    setErrSearchValue(null); 
    setHower(true)    
    setSearchTerm(e.target.value);   
    getTeamsAPI(e.target.value, true)
    setPagnation({ selectedPage: 1 })    
  }

  const onSearch = () => {   
    setErrSearchValue(null);    
    if(getSearchTerm == ''){      
      setErrSearchValue("Please enter a search term.");
      return;
    }
    getTeamsAPI(getSearchTerm, true)
    setPagnation({ selectedPage: 1 })
  }


  const clearText = () => {
    refContainer.current.reset();
    setErrSearchValue(null); 
    setSearchTerm('');
    getTeamsAPI();
  }
  return (
    <div className={classes.filterTable} data-testid='all_team_table'>
      <form ref={refContainer} noValidate autoComplete="off">
        {errSearchValue ? <InputLabel className={classes.errMsg} htmlFor="input-with-icon-textfield">{errSearchValue}</InputLabel> : null}
        <TextField
          id="input-with-icon-textfield"
          placeholder="Search"
          onChange={(e) => searchField(e)}
          onKeyPress={(e) => kekPressSearch(e)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start" onClick={onSearch}>
                <SearchIcon style={{ cursor: 'pointer' }} />
              </InputAdornment>
            ),
            endAdornment: (
              <InputAdornment position="end">
                {hover && <FontAwesomeIcon icon={faTimes} className={classes.crossCursor} onClick={clearText} />}
              </InputAdornment>
            ),
          }}

        />      
        
      </form>
      <MaterialTable
        icons={tableIcons}
        title={false}
        columns={[
          {
            title: 'Name', field: 'team_name', cellStyle: {
              width: '25%',
            },
            render: rowData => <NavLink to="#" className={classes.tdLink} onClick={() => { props.teamDetailstab(rowData.teams_id) }}>{rowData.team_name}</NavLink>,
            headerStyle: {
              width: '25%',
            }
          },
          {
            title: 'No Of Users', field: 'total_user', type: 'numeric', cellStyle: {
              width: '12%'
            },
            headerStyle: {
              width: '12%',
            }
          },
          { title: 'Description', field: 'description' },

        ]}
        data={teamList ? teamList : []}
        totalCount={totalItems}
        options={{
          filtering: false,
          sorting: false,
          paging: pages,
          pageSize: 10,
          pageSizeOptions: [10, 20],
          search: false
        }}
        
        components={
          userAccess == true ?            
            getLoader == false ?

              {
                Pagination: props => (
                  <TablePagination
                    {...props}
                    count={totalItems}
                    page={pagination.selectedPage - 1}
                    onChangePage={handleSelected}
                    rowsPerPage={enteriesPerPage}
                  />
                ),
              }
              :
              {
                Pagination: props => (
                  <TablePagination
                    {...props}
                    count={totalItems}
                    page={pagination.selectedPage - 1}
                    onChangePage={handleSelected}
                    rowsPerPage={enteriesPerPage}
                  />
                ),
                Body: (props) => (
                  <tbody><tr style={{ height: '49px' }}><td colspan="4" style={{ paddingTop: '0px', paddingBottom: '0px', textAlign: 'center' }}><span style={{ color: '#CC0000', fontWeight: '600' }}><CircularProgress /></span> </td></tr></tbody>
                )
              }
            : {
              Pagination: props => (
                <TablePagination
                  {...props}
                  count={totalItems}
                  page={pagination.selectedPage - 1}
                  onChangePage={handleSelected}
                  rowsPerPage={enteriesPerPage}
                />
              ),
              Body: (props) => (
                <tbody><tr style={{ height: '49px' }}><td colspan="4" style={{ paddingTop: '0px', paddingBottom: '0px', textAlign: 'center' }}><span style={{ color: '#CC0000', fontWeight: '600' }}><FontAwesomeIcon icon={faTimes} /> Access Forbidden</span> </td></tr></tbody>
              )
            }
        }
      />
    </div>
  )
}

export default Teams;
//End Teams component code...